<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{$t('MODALINFOEXAME.INFO')}}</p>
        </header>
        <section class="modal-card-body">
            <div v-for="(exame,index) in selecionado" :key="index">
                <div class="columns panel-list-item">
                    <div class="column is-1">
                        <p class="heading">{{$t('MODALINFOEXAME.GUIAITEM')}}</p>
                        <p class="subtitle">
                            {{ guia.id }} - {{ exame.item }}
                        </p>
                    </div>
                    <div class="column is-4">
                        <p class="heading">{{$t('MODALINFOEXAME.EXAME')}}</p>
                        <p class="subtitle">
                            <b>{{ exame.exameApelido }}</b> - <b>{{ exame.exameNome }}</b> ({{ exame.exameId }})
                        </p>
                    </div>
                    <div class="column">
                        <p class="heading">{{$t('MODALINFOEXAME.SETOR')}}</p>
                        <p class="subtitle">
                            <b>{{ exame.exameSetorNome }}</b> ({{ exame.exameSetorId }})
                        </p>
                    </div>
                    <div class="column">
                        <p class="heading">{{$t('MODALINFOEXAME.DATAENTREGA')}}</p>
                        <p class="subtitle">
                            <span>{{ exame.dataDeEntrega | moment('DD/MM/YYYY [às] HH:mm') }}</span>
                        </p>
                    </div>
                    <div class="column" v-if="guia.unidadeDeCadastroId">
                        <p class="heading">{{$t('MODALINFOEXAME.UNIDADE')}}</p>
                        <p class="subtitle">
                            <b>{{ guia.unidadeDeCadastroNome }}</b> ({{ guia.unidadeDeCadastroId }})
                        </p>
                    </div>
                    <div class="column" v-if="exame.codigoIntegracao">
                        <p class="heading">{{$t('MODALINFOEXAME.CODIGOINTEGRACAO')}}</p>
                        <p class="subtitle">
                            <b>{{ exame.codigoIntegracao }}</b>
                        </p>
                    </div>
                    <div class="column">
                        <p class="heading">{{$t('MODALINFOEXAME.ULTIMAMODIFICACAO')}}</p>
                        <p class="subtitle">
                            {{ guia.dataUltimaModificacao | moment('DD/MM/YYYY [às] HH:mm') }}
                        </p>
                    </div>
                </div>
                <div class="columns is-multiline panel-list-item" v-for="(log,index) in itemLog(exame)" :key="index">
                    <div class="column is-5">
                        <h5 class="is-size-5">
                            {{ log.descricao }}
                            <a v-if="log.status == 8 && !log.exclusao" 
                            @click="acessaBancada(log.dados)" 
                                class="button is-small is-primary" :title="$t('MODALINFOEXAME.BANCADA')">
                                <b-icon icon="eye" size="is-small"></b-icon>
                            </a>
                            <a v-if="log.status == 512 && !log.exclusao" 
                            @click="acessaFatura(tratarDados(log.dados))" 
                                class="button is-small is-primary" :title="$t('MODALINFOEXAME.CONTARECEBER')">
                                <b-icon icon="pencil" size="is-small"></b-icon>
                            </a>
                        </h5>
                    </div>
                    <div class="column is-3">
                        {{ dataPorExtenso(log.dataHora) }}
                    </div>
                    <div class="column">
                        <p>
                            por <b>{{ log.usuarioNome }}</b>
                        </p>
                        <p v-if="log.unidadeId">
                            {{$t('MODALINFOEXAME.NAUNIDADE')}} <b>{{ log.unidadeNome }}</b> ({{ log.unidadeId }})
                        </p>
                    </div>
                    <div v-if="log.info || log.exclusao" class="column is-2 has-text-right">
                        <b-tag v-if="log.info">{{ log.info }}</b-tag>
                        <b-tag v-show="log.exclusao" type="is-danger" rounded>X</b-tag>
                    </div>
                    <div v-if="isInRole('resultado-visualizar') && (log.status == 524288 || log.status == 536870912 || log.status == 4096 || log.status == 2097152)/*ResultadoRetificado/Repetido*/" class="column is-12">
                        <div class="box">
                            <table class="table table-striped table-hover table-condensed table-bordered is-fullwidth">
                                <thead>
                                    <th v-if="log.status == 524288" colspan="2" class="is-warning">{{$t('MODALINFOEXAME.RESULTADORETIFICACAO')}}</th>
                                    <th v-if="log.status == 536870912" colspan="2" class="is-warning">{{$t('MODALINFOEXAME.RESULTADOREPETICAO')}}</th>
                                    <th v-if="log.status == 2097152" colspan="2" class="is-warning">{{$t('MODALINFOEXAME.RESULTADONOVO')}}</th>
                                </thead>
                                <tbody>
                                        <tr v-for="(item,j) in log.itens" :key="j">
                                            <td v-if="item.campoTitulo != null" class="has-text-left">{{item.campoTitulo}}</td>
                                            <td v-else class="has-text-left">{{item.campoNome}}</td>
                                            <td class="has-text-right">
                                                <img v-if="item.campoTipoValor == 'G'" :src="'data:image/png;base64,' + item.valor" />
                                                <div v-else-if="item.campoTipoValor == 'D'" class="MascaraCampoDiv">
                                                    <div>{{item.valor}}</div>
                                                </div>
                                                <span v-else>{{item.valorFormatado}}</span>
                                            </td>
                                        </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$emit('close')">{{$t('MODALINFOEXAME.FECHAR')}}</button>
        </footer>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    export default {
        props: {
            guia: Object,
            selecionado: Array
        },
        data() {
            return {
                lista: []
            }
        },
        computed: {
            ...mapGetters([
                'isInRole'
            ])
        },
        mounted() {
            this.loadLista()
        },
        methods: {
            dataPorExtenso(dataHora){
                dataHora = new Date(dataHora);
                const day = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"][dataHora.getDay()];
                const date = dataHora.getDate();
                const month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][dataHora.getMonth()];
                const year = dataHora.getFullYear();

                return `${day}, ${date} de ${month} de ${year} às ${this.$moment(dataHora).format('HH:mm:ss')}`;
            },
            loadLista() {
                this.$http.get('/api/atendimento/infoExame{?id,item*}', {
                    params: {
                        id: this.guia.id,
                        item: this.selecionado.map(x => x.item)
                    }
                })
                    .then(res => {
                        this.lista = res.data
                    })
            },
            itemLog(guiaexame) {
                return this.lista.filter(x => x.guiaItem === guiaexame.item)
            },
            acessaFatura(id) {                
                this.$emit('close');
                this.$router.push({ path: `/financeiro/receber/${id}` })
            },
            acessaBancada(numero) {     
                window.open('/Analise/Bancada?id=' + numero);
            },
            tratarDados(str) {                                                                
                return str.replace('%', '').replace('(', '').replace(')', '')
                        .replace('"', '').replace('"', '').replace(',', '').replace('Receber: ', '');
            }            
        }
    }
</script>